'use strict';

// Shared invoice zip queuing and print-options report submit UX used by
// the print options dialog (ajax_generic_window.cfm) and the reprint
// invoices screen (billing_reprint_invoices.cfm). Translatable strings
// are passed in via the `text` option so translation stays server-side.

export function showZipQueuedPanel({
    popID = 'popInvoicesGenerating',
    message = '',
    alreadyQueued = false,
    text = {},
} = {}) {
    // eslint-disable-next-line max-len
    var defaultMsg = text.defaultMessage || "When it's ready we'll email you and show it in Tasks & Downloads.";
    var msg = (message && message.length > 0) ? message : defaultMsg;
    var heading = text.heading || 'Your invoice zip is being prepared';
    var goDownloads = text.goToDownloads || 'Go to Tasks & Downloads';

    var headingClass = alreadyQueued ? 'zip-already-queued' : '';
    var headingStyle = alreadyQueued ? ' style="color:#c0392b;"' : '';

    var html =
        '<div style="padding:1em;">' +
            '<h2 class="' + headingClass + '"' + headingStyle + '>' + heading + '</h2>' +
            '<p>' + msg + '</p>' +
            '<a class="button is-primary mt-4" href="/?page=my_downloads">' + goDownloads + '</a>' +
        '</div>';

    $('#' + popID).html(html);
}

export function enqueueInvoiceZip({
    formObj,
    popID = 'popInvoicesGenerating',
    text = {},
    openPopup = true,
} = {}) {
    if (openPopup) {
        // eslint-disable-next-line max-len
        var popWaitMessage = text.popWaitMessage || 'Invoices are being generated. This may take some time.<br>Please wait...';

        popWin({
            popID: popID,
            title: text.popTitle || 'Generating Invoices',
            modal: true,
            hideCloseButton: false,
            closeOnEscape: true,
            width: 600,
            noAutoWidth: true,
            contents: loadingBox({
                classes: 'popEmailLoading',
                waitMessage: popWaitMessage,
            }),
        });
    }

    $.ajax({
        type: 'POST',
        url: '/components/invoice.cfc?method=enqueueInvoiceZipWeb',
        data: formObj.serialize(),
        dataType: 'JSON',
        cache: false,
        success: function (data) {
            if (data && (data.SUCCESS || data.ALREADYQUEUED)) {
                showZipQueuedPanel({
                    popID: popID,
                    message: data.MESSAGE,
                    alreadyQueued: data.ALREADYQUEUED,
                    text: text,
                });
            } else {
                popWinClose(popID);
                EQLAPP.STRIPE.showAlert({
                    title: 'Alert',
                    // eslint-disable-next-line max-len
                    body: (data && data.MESSAGE) ? data.MESSAGE : 'Unable to queue your invoice zip at this time. Please try again.',
                });
            }
        },
        error: function () {
            popWinClose(popID);
            EQLAPP.STRIPE.showAlert({
                title: 'Alert',
                body: 'Unable to connect to equisoft Live at this time. Please try again.',
            });
        },
    });
}

// Queues an invoice review and keeps the existing loading popup until the
// batch is ready. The Continue button counts down from 10 and then redirects.
export function enqueueInvoiceReview({
    popID = 'popInvoicesGenerating',
    data = {},
    text = {},
} = {}) {
    const completeHeading = text.completeHeading || 'Complete';
    const completeBody = text.completeBody || 'Your invoices are ready to review.';
    const continueLabel = text.continueLabel || 'Continue';
    const failedHeading = text.failedHeading || 'Unable to prepare invoices';
    const failedBody = text.failedBody || 'Unable to prepare your invoices for review. Please try again.';
    const redirectSeconds = 10;

    let pollTimer = null;
    let countdownTimer = null;
    let settled = false;

    function stopTimers() {
        if (pollTimer) {
            clearInterval(pollTimer);
            pollTimer = null;
        }
        if (countdownTimer) {
            clearInterval(countdownTimer);
            countdownTimer = null;
        }
    }

    function popupStillOpen() {
        const $pop = $('#' + popID);
        return $pop.length > 0 && $pop.closest('.ui-dialog').is(':visible');
    }

    $('#' + popID).unbind('dialogclose.invoiceReview').bind('dialogclose.invoiceReview', () => {
        stopTimers();
    });

    $.ajax({
        type: 'POST',
        url: '/components/invoice.cfc?method=enqueueInvoiceReviewWeb',
        data: data,
        dataType: 'JSON',
        cache: false,
        success: function (result) {
            const redirectURL = (result && result.REDIRECTURL) ? result.REDIRECTURL : '';
            const jobUUID = (result && result.JOBUUID) ? result.JOBUUID : '';
            if (result && result.SUCCESS && redirectURL.length > 0 && jobUUID.length < 1) {
                window.location = redirectURL;
                return;
            }
            if (result && result.SUCCESS && jobUUID.length > 0) {
                allowPopupClose(popID);
                pollReviewJob(jobUUID);
                pollTimer = setInterval(() => pollReviewJob(jobUUID), 2000);
            } else {
                popWinClose(popID);
                EQLAPP.STRIPE.showAlert({
                    title: 'Alert',
                    body: (result && result.MESSAGE) ? result.MESSAGE : failedBody,
                });
            }
        },
        error: function () {
            popWinClose(popID);
            EQLAPP.STRIPE.showAlert({
                title: 'Alert',
                body: 'Unable to connect to equisoft Live at this time. Please try again.',
            });
        },
    });

    function pollReviewJob(jobUUID) {
        if (!popupStillOpen()) {
            stopTimers();
            return;
        }

        $.ajax({
            type: 'GET',
            url: '/components/invoice.cfc?method=getInvoiceReviewJobStatusWeb',
            data: { jobUUID: jobUUID },
            dataType: 'JSON',
            cache: false,
            success: function (result) {
                if (settled || !popupStillOpen()) {
                    stopTimers();
                    return;
                }
                if (!result || !result.SUCCESS) {
                    settled = true;
                    stopTimers();
                    showReviewFailed(popID, failedHeading, (result && result.MESSAGE) ? result.MESSAGE : failedBody);
                    allowPopupClose(popID);
                    return;
                }
                if (result.STATUS === 'Ready' && result.REDIRECTURL) {
                    settled = true;
                    stopTimers();
                    showReviewComplete({
                        popID: popID,
                        redirectURL: result.REDIRECTURL,
                        heading: completeHeading,
                        body: completeBody,
                        continueLabel: continueLabel,
                        seconds: redirectSeconds,
                        onTick: (timerId) => { countdownTimer = timerId; },
                    });
                    allowPopupClose(popID);
                } else if (result.STATUS === 'Failed') {
                    settled = true;
                    stopTimers();
                    showReviewFailed(popID, failedHeading, result.MESSAGE || failedBody);
                    allowPopupClose(popID);
                }
            },
        });
    }
}

function showReviewComplete({
    popID,
    redirectURL,
    heading,
    body,
    continueLabel,
    seconds,
    onTick,
} = {}) {
    let remaining = seconds;
    const html =
        '<div style="padding:1em;">' +
            '<h2>' + escapeReviewHtml(heading) + '</h2>' +
            '<p>' + escapeReviewHtml(body) + '</p>' +
            '<a class="button is-primary mt-4 js-review-continue" href="' + escapeReviewHtml(redirectURL) + '">' +
                escapeReviewHtml(continueLabel) + ' (' + remaining + ')' +
            '</a>' +
        '</div>';

    $('#' + popID).html(html);

    const $continue = $('#' + popID).find('.js-review-continue');
    let timerId = null;

    function goNow() {
        if (timerId) {
            clearInterval(timerId);
            timerId = null;
        }
        window.location = redirectURL;
    }

    $continue.bind('click', (event) => {
        event.preventDefault();
        goNow();
    });

    timerId = setInterval(() => {
        remaining -= 1;
        if (remaining <= 0) {
            clearInterval(timerId);
            goNow();
            return;
        }
        $continue.text(continueLabel + ' (' + remaining + ')');
    }, 1000);

    if (typeof onTick === 'function') {
        onTick(timerId);
    }
}

function showReviewFailed(popID, heading, message) {
    const html =
        '<div style="padding:1em;">' +
            '<h2>' + escapeReviewHtml(heading) + '</h2>' +
            '<p>' + escapeReviewHtml(message) + '</p>' +
        '</div>';
    $('#' + popID).html(html);
}

function allowPopupClose(popID) {
    $('#' + popID).closest('.ui-dialog').find('.ui-dialog-titlebar-close').customShow();
}

function escapeReviewHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

// Native XHR (jQuery 1.5 cannot request a blob). onload is the completion
// signal that a streaming cfreport form POST never gives the popup.
export function submitPrintOptionsReport({
    formObj,
    text = {},
    onSuccess,
} = {}) {
    if (!formObj || !formObj.length || formObj.data('reportInProgress')) {
        return;
    }

    const waitMessage = text.waitMessage ||
        'Generating report. This may take some time.<br>Please wait...';
    const errorMessage = text.errorMessage ||
        'Unable to generate the report. Please try again.';

    const $btn = formObj.find('[name="btnShowReport"]');
    const $format = formObj.find('[name="reportFormat"]');
    const $close = formObj.find('[name="btnClose"]');
    let $loader = formObj.find('.js-print-options-loader');

    if (!$loader.length) {
        $loader = $('<div class="js-print-options-loader hide"></div>');
        formObj.append($loader);
    }

    const reportFormat = String($format.val() || 'pdf').toLowerCase();
    const isPdf = reportFormat === 'pdf';
    const formAction = formObj.attr('action');
    const postedData = formObj.serialize();
    const loaderID = 'printOptionsLoading_' + (formObj.attr('id') || 'report');

    // PDF: native POST into the generating tab so the fetch survives
    // navigating away from the opener. Close the print popup immediately.
    if (isPdf) {
        relayPdfToGeneratingTab(formObj, formAction);
        if (typeof onSuccess === 'function') {
            onSuccess();
        }
        return;
    }

    setReportBusy(true);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', formAction, true);
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onload = () => {
        const blob = xhr.response;
        const contentType = (
            xhr.getResponseHeader('Content-Type') ||
            (blob && blob.type) ||
            ''
        ).toLowerCase();

        if (xhr.status < 200 || xhr.status >= 300 || isHtmlOrTextContent(contentType)) {
            showReportError(errorMessage);
            setReportBusy(false);
            return;
        }

        const filename = filenameFromDisposition(
            xhr.getResponseHeader('Content-Disposition'),
            defaultReportFilename(formObj, false),
        );

        downloadBlob(blob, filename);
        setReportBusy(false);

        if (typeof onSuccess === 'function') {
            onSuccess();
        }
    };

    xhr.onerror = () => {
        showReportError(errorMessage);
        setReportBusy(false);
    };

    xhr.send(postedData);

    function setReportBusy(busy) {
        formObj.data('reportInProgress', busy);
        setControlDisabled($btn, busy);
        setControlDisabled($format, busy);

        if (busy) {
            $loader.html(loadingBox({
                classes: 'popEmailLoading',
                waitMessage: waitMessage,
                loaderID: loaderID,
            })).customShow();
            $close.customShow();
        } else {
            $loader.empty().customHide();
        }
    }
}

function relayPdfToGeneratingTab(formObj, formAction) {
    const formEl = formObj[0];
    if (!formEl) {
        return;
    }

    let $actionField = formObj.find('[name="printReportAction"]');
    if (!$actionField.length) {
        $actionField = $('<input type="hidden" name="printReportAction">');
        formObj.append($actionField);
    }
    $actionField.val(formAction);

    const originalAction = formObj.attr('action');
    const originalTarget = formObj.attr('target') || '';

    formObj.attr('action', 'pages/report_generating.cfm');
    formObj.attr('target', '_blank');
    formEl.submit();
    formObj.attr('action', originalAction);
    formObj.attr('target', originalTarget);
}

function setControlDisabled($el, disabled) {
    if (!$el || !$el.length) {
        return;
    }

    if (disabled) {
        $el.attr('disabled', 'disabled');
    } else {
        $el.removeAttr('disabled');
    }

    if ($el.data('button')) {
        $el.button(disabled ? 'disable' : 'enable');
    }
}

function downloadBlob(blob, filename) {
    if (typeof URL === 'undefined' || !URL.createObjectURL) {
        return;
    }

    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename || 'report.xls';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => {
        URL.revokeObjectURL(objectUrl);
    }, 60000);
}

function isHtmlOrTextContent(contentType) {
    return contentType.indexOf('html') !== -1 ||
        contentType.indexOf('text/plain') !== -1;
}

function filenameFromDisposition(header, fallback) {
    if (!header) {
        return fallback;
    }

    const utfMatch = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
    if (utfMatch) {
        try {
            return decodeURIComponent(utfMatch[1].replace(/['"]/g, ''));
        } catch {
            // fall through
        }
    }

    const nameMatch = /filename="?([^";]+)"?/i.exec(header);
    if (nameMatch) {
        return nameMatch[1];
    }

    return fallback;
}

function defaultReportFilename(formObj, isPdf) {
    const reportName = formObj.find('[name="reportname"]').val() ||
        formObj.find('[name="report"]').val() ||
        'report';
    return reportName + (isPdf ? '.pdf' : '.xls');
}

function showReportError(message) {
    if (window.EQLAPP && EQLAPP.STRIPE && EQLAPP.STRIPE.showAlert) {
        EQLAPP.STRIPE.showAlert({
            title: 'Alert',
            body: message,
        });
        return;
    }
    alert(message);
}
